// extracted by mini-css-extract-plugin
export default {"container":"E0-z","list":"F0-z"};